import React from 'react';
import './blog-post.css';
import './blog-slides.css';

const CherryBlossoms = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Cherry Blossom LinkedIn Headshots</h2>
                    <p className="site-post-meta">March 31, 2026</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you to everyone who came to our Cherry Blossom LinkedIn Headshots today! We hope you guys had an amazing time enjoying the cherry blossoms and getting an amazing picture.
                    <br></br>
                    <br></br>
                    Thanks to our lovely Social Media Director, Ioli, we already have your pictures ready!! Everyone should have recieved an email with the Google Drive link to the pictures (be sure to log in with your CSE email).
                    <br></br>
                    <br></br>
                    </p>

                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default CherryBlossoms;
